<div class="modal-header" id="travel-status-update-modal-title">
    <h3 class="modal-title">{{ model.statusLabel }}</h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>

<div class="modal-body h-50 overflow-auto" id="modal-body">
    <form [formGroup]="travelStatusForm">
        <fieldset formArrayName="formChildren" class="p-2">
            <div class="row mb-3 align-items-center">
                <label class="col-12 col-form-label text-start">Start Date & Time</label>
                <div class="col-12">
                    <div class="row g-2">
                        <div class="col-12 col-lg-5 pr-3">
                            <pace-core-date-input
                                [(model)]="model.date"
                                (valueChange)="updateValidityAndEndMoment()"
                                [parentForm]="formChildren"
                                [ariaLabel]="'TRAVEL_STATUS_START_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-12 col-lg-4">
                            <pace-core-time-input
                                [(model)]="model.time"
                                (valueChange)="updateValidityAndEndMoment()"
                                [parentForm]="formChildren"
                                [ariaLabel]="'TRAVEL_STATUS_START_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                        <div class="col-12 col-lg-3">
                            <button
                                class="btn btn-primary w-100 w-md-auto px-2"
                                *ngIf="!isLoading"
                                [disabled]="travelStatusForm.invalid"
                                (click)="submitStatus()"
                            >
                                {{ model.statusLabel }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Date & Time -->
            <div class="row mb-3 align-items-center" *ngIf="model.nextStatusETA()">
                <label class="col-12 col-form-label text-start"> End Date & Time </label>
                <div class="col-12">
                    <div class="row g-2">
                        <div class="col-12 col-lg-5">
                            <pace-core-date-input
                                [(model)]="model.endDate"
                                [parentForm]="formChildren"
                                [ariaLabel]="'TRAVEL_STATUS_END_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-12 col-lg-4">
                            <pace-core-time-input
                                [(model)]="model.endTime"
                                [parentForm]="formChildren"
                                [ariaLabel]="'TRAVEL_STATUS_END_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Loading Indicator -->
            <div class="text-center mt-3">
                <progressbar *ngIf="isLoading" [striped]="true" [value]="100" type="default">
                    Updating status...
                </progressbar>
            </div>
        </fieldset>
    </form>

    <div class="container d-flex flex-column">
        <div class="row flex-grow-1 overflow-auto" *ngIf="model.nextStatusETA()">
            <div class="col contract-info" tabindex="0">
                <pace-contract-information [model]="model.notification.contract"></pace-contract-information>
            </div>
        </div>
    </div>
</div>
